import BookGroup from "components/BookGroup";
import Divider from "components/ui/Divider";
import Container from "hardcover-ui/components/Container";
import SimilarBooksHeader from "./SimilarBooksHeader";
import { BookSerializersBookByline } from "types/serializers";

export default function SimilarBooks({ similarBooks }: { similarBooks: BookSerializersBookByline[] }) {
  if (similarBooks.length === 0) {
    return <></>;
  }

  return (
    <Container variant="layout" size="md">
      <h2 className="sr-only">Related Books</h2>
      <BookGroup
        size="lg"
        books={similarBooks}
        HeaderComponent={SimilarBooksHeader}
      />

      <Divider size="lg" />
    </Container>
  );
}
